import styled from 'styled-components'
//Route
import {Link as LinkR} from 'react-router-dom'
//Scroll
import {Link as LinkS} from 'react-scroll'


export const Nav = styled.nav`
    background: ${ ({scrollNav}) => (scrollNav ? '#000 ' : 'transparent transition: 0.3s ease') };
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    filter: drop-shadow(0 0.5mm 4mm rgba(255, 255, 254, 0.4));
    @media screen and (max-width: 960px){
        transition: 0.9s all ease;
    }
`

export const NavContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
    align-items:center;
`

export const NavLogo = styled(LinkR) `
    color: #FFF;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;
`

export const MobileIco = styled.div `
    display:none;

    @media screen and (max-width: 768px){
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 70%);
        font-size: 1.7rem;
        cursor: pointer;
        color:#fff;
    }   
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 768px){
        display:none;
    }
`

export const NavItem = styled.li`
    height: 80px;
`

export const NavLinks = styled(LinkS)`
    color: #fff;
    display:flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor:pointer;
    font-weight: 500;

    
`;

export const NavBtn = styled.nav`
    display:flex;
    align-items:center;

    @media screen and (max-width: 768px){
        display:none;
    }
`

export const NavBtnLink = styled(LinkR)`
    border-radius: 3rem;
    background: #51C4D3;
    white-space: no-wrap;
    padding: 10px 22px;
    color: #010606;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    font-weight: bold;
    &:hover{
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #010606;
    }
`;